import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useClinicContext } from 'src/Utils/Hooks/ClinicContext';

import './OwnerPermissionNote.css';

/**
 * "Only Owners can purchase, update, or cancel an Aura App subscription."
 *
 * Shown in both payment dialogs. Reads owner status from clinic context, so
 * callers don't have to thread it through: informational black for an Owner,
 * a red error notice for everyone else.
 *
 * Figma: 100227:559757 (owner) / 100227:559843 (non-owner)
 */
const OwnerPermissionNote: React.FC = () => {
    const { t } = useTranslation();
    const { currentUser } = useClinicContext();
    const isClinicOwner = currentUser?.isClinicOwner ?? false;

    return (
        <div className={`owner-note${isClinicOwner ? '' : ' owner-note--error'}`}>
            <strong>{t('OnlyOwnersCanManageSubscription')}</strong>
            <br />
            <Trans
                i18nKey="ModifyUserPermissions"
                components={{ usersLink: <Link to="/users" className='owner-note__users-link' /> }}
            />
        </div>
    );
};

export default OwnerPermissionNote;
